import { ApiService } from './index'
import { Location, Hive, Group, ApiResponse } from '@types'

export const locationsApi = {
  // Apiaries
  getApiaries: () =>
    ApiService.get<ApiResponse<Location[]>>('/locations/'),
  getApiary: (id: number) =>
    ApiService.get<ApiResponse<Location>>(`/locations/${id}/`),

  createApiary: (data: Partial<Location>) =>
    ApiService.post<ApiResponse<Location>>('/locations/', data),

  updateApiary: (id: number, data: Partial<Location>) =>
    ApiService.patch<ApiResponse<Location>>(`/locations/${id}/`, data),

  deleteApiary: (id: number) =>
    ApiService.delete(`/locations/${id}/`),

  // Hives
  getHives: () =>
    ApiService.get<ApiResponse<Hive[]>>('/hives/'),

  getHive: (id: number) =>
    ApiService.get<ApiResponse<Hive>>(`/hives/${id}/`),

  createHive: (data: Partial<Hive>) =>
    ApiService.post<ApiResponse<Hive>>('/hives/', data),

  updateHive: (id: number, data: Partial<Hive>) =>
    ApiService.patch<ApiResponse<Hive>>(`/hives/${id}/`, data),

  deleteHive: (id: number) =>
    ApiService.delete(`/hives/${id}/`),

  // Groups
  getGroups: () =>
    ApiService.get<ApiResponse<Group[]>>('/groups/'),

  getGroup: (id: number) =>
    ApiService.get<ApiResponse<Group>>(`/groups/${id}/`),

  createGroup: (data: Partial<Group>) =>
    ApiService.post<ApiResponse<Group>>('/groups/', data),

  updateGroup: (id: number, data: Partial<Group>) =>
    ApiService.patch<ApiResponse<Group>>(`/groups/${id}/`, data),

  deleteGroup: (id: number) =>
    ApiService.delete(`/groups/${id}/`),

  joinGroup: (id: number, token: string) =>
    ApiService.post<ApiResponse<Group>>(`/groups/${id}/join/`, { token }),

  leaveGroup: (id: number) =>
    ApiService.post<ApiResponse<{ message: string }>>(`/groups/${id}/leave/`),
}
